const startTime = +new Date();

export const globalStartTime = () => startTime;
